import React, { useEffect, useState } from 'react';
import './home-styles/home-section7.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules'; // Include Autoplay
import { database } from '../../firebase';
import { ref, get } from 'firebase/database';

const HomeSection7 = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const reviewsRef = ref(database, 'reviews');
    get(reviewsRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const reviewsArray = Object.keys(data).map((key) => ({
            id: key,
            ...data[key],
          }));
          setReviews(reviewsArray);
        } else {
          console.log("No reviews found in the database.");
        }
      })
      .catch((error) => {
        console.error("Error fetching reviews:", error);
      });
  }, []);

  return (
    <div className="home-section7">
      <div className="section dark-section">
        <h2 className="section-title">REVIEWS</h2>

        {reviews.length === 0 ? (
          <p className="no-reviews-text">No reviews yet.</p>
        ) : (
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 10000, disableOnInteraction: false }} // 10s slide
            className="review-swiper"
          >
            {reviews.map((review) => (
              <SwiperSlide key={review.id}>
                <div className="review-card">
                  <img
                    src={review.image || 'default-image.jpg'}
                    alt={review.name}
                    className="review-image"
                  />
                  <div className="review-text">
                    <p>
                      <strong>{review.name}</strong> – <em>{review.designation}</em>
                    </p>
                    <p className="quote">"{review.review}"</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
};

export default HomeSection7;
